module.exports = __webpack_public_path__ + "images/emoji/sweet_potato.960c02827d515ca5da59.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sweet_potato.png
// module id = bD6p
// module chunks = 24